module.exports = __webpack_public_path__ + "img/ckdirect.testB.2153f8c9.png";